/**
 * Frontend Lightbox - GLightbox Moderno (sin jQuery)
 * Reemplaza completamente Lightbox2 legacy
 */

import GLightbox from 'glightbox';
import 'glightbox/dist/css/glightbox.min.css';

export class FrontendLightbox {
    constructor() {
        this.lightbox = null;
        this.isInitialized = false;
        this.init();
    }

    init() {
        if (this.isInitialized) return;
        
        // Configuración moderna de GLightbox
        this.lightbox = GLightbox({
            selector: '[data-lightbox]',
            touchNavigation: true,
            loop: true,
            autoplayVideos: false,
            zoomable: true,
            draggable: true,
            svg: {
                download: '<svg class="gslide-icon gslide-download" viewBox="0 0 24 24"><path d="M12 16l4-4h-3V4h-2v8H8l4 4zM20 18H4v-2h16v2z"/></svg>',
                zoom: '<svg class="gslide-icon gslide-zoom" viewBox="0 0 24 24"><path d="M15.5 14h-.79l-.28-.27A6.5 6.5 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5.5 12.49 5.5 10.5S7.01 7 9.5 7 13.5 8.51 13.5 10.5 11.99 14 9.5 14z"/></svg>',
                close: '<svg class="gslide-icon gslide-close" viewBox="0 0 24 24"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>'
            },
            lightboxHtml: `
                <div id="glightbox-body" class="glightbox-container">
                    <div class="gloader visible"></div>
                    <div class="goverlay"></div>
                    <div class="gcontainer">
                        <div id="glightbox-slider" class="gslider"></div>
                        <button class="gclose gbtn" aria-label="Close">{closeSVG}</button>
                        <button class="gprev gbtn" aria-label="Previous">{prevSVG}</button>
                        <button class="gnext gbtn" aria-label="Next">{nextSVG}</button>
                    </div>
                </div>
            `,
            slideHtml: `
                <div class="gslide">
                    <div class="gslide-inner-content">
                        <div class="ginner-container">
                            <div class="gslide-media">
                            </div>
                            <div class="gslide-description">
                                <div class="gdesc-inner">
                                    <h4 class="gslide-title"></h4>
                                    <div class="gslide-desc"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            `,
            skin: 'clean',
            moreLength: 60,
            cssEfects: {
                fade: { in: 'fadeIn', out: 'fadeOut' },
                zoom: { in: 'zoomIn', out: 'zoomOut' },
                slide: { in: 'slideInRight', out: 'slideOutLeft' },
                slideBack: { in: 'slideInLeft', out: 'slideOutRight' },
                none: { in: 'none', out: 'none' }
            },
            openEffect: 'fade',
            closeEffect: 'fade'
        });
        
        this.isInitialized = true;
        console.log('✅ GLightbox inicializado - Sistema moderno sin jQuery');
        
        // Migrar elementos legacy automáticamente
        this.migrateLegacyElements();
    }
    
    /**
     * Migrar elementos legacy de lightbox2 a GLightbox
     */
    migrateLegacyElements() {
        // Buscar elementos con data-lightbox="image-1" (legacy)
        const legacyElements = document.querySelectorAll('[data-lightbox="image-1"], [data-lightbox="image"]');
        
        legacyElements.forEach(element => {
            // Cambiar a formato GLightbox
            element.setAttribute('data-lightbox', 'gallery');
            
            // Añadir título si no existe
            if (!element.hasAttribute('data-glightbox')) {
                const alt = element.querySelector('img')?.alt || element.getAttribute('alt') || 'Imagen';
                element.setAttribute('data-glightbox', `title: ${alt}`);
            }
        });
        
        if (legacyElements.length > 0) {
            console.log(`✅ ${legacyElements.length} elementos legacy migrados a GLightbox`);
            
            // Refrescar GLightbox para reconocer nuevos elementos
            this.refresh();
        }
    }
    
    /**
     * Refrescar GLightbox para reconocer nuevos elementos
     */
    refresh() {
        if (this.lightbox) {
            this.lightbox.reload();
            console.log('🔄 GLightbox refrescado');
        }
    }
    
    /**
     * Destruir instancia de GLightbox
     */
    destroy() {
        if (this.lightbox) {
            this.lightbox.destroy();
            this.lightbox = null;
            this.isInitialized = false;
            console.log('🧹 GLightbox destruido');
        }
    }
    
    /**
     * Abrir imagen específica por URL
     */
    openImage(imageUrl, title = '') {
        if (!this.lightbox) return;
        
        this.lightbox.openAt({
            href: imageUrl,
            type: 'image',
            title: title
        });
    }
    
    /**
     * Obtener estadísticas del lightbox
     */
    getStats() {
        const lightboxElements = document.querySelectorAll('[data-lightbox]');
        const galleryElements = document.querySelectorAll('[data-lightbox="gallery"]');
        
        return {
            totalElements: lightboxElements.length,
            galleryElements: galleryElements.length,
            isInitialized: this.isInitialized
        };
    }
}
